/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { STATUS_ADMINISTRATIVE_PROCEEDINGS } from "../leadStatus";
import { Divider, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { getCaseDocumentUploadLink, getCaseLink } from "../../productService";
import React from "react";
import { Link } from "react-router";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";

export const ExtraContent = ({ litigationCase }: { litigationCase: AbstractCase }) => {
  if (litigationCase.leadStatus === STATUS_ADMINISTRATIVE_PROCEEDINGS) {
    return (
      <Stack spacing={2} sx={{ marginTop: 2 }}>
        <Divider />
        <ProductBoxGrid
          items={[
            <Typography>
              Es kam inzwischen zu einer Einigung mit der Gegenseite und der Fall kann abgeschlossen werden? Dann teilen Sie uns dies bitte hier kurz mit:
            </Typography>,
            <Button component={Link} to={getCaseLink(litigationCase) + "/abschliessen"} variant="outlined" color="primary" fullWidth>
              Fall abschließen
            </Button>,
          ]}
        />
        <Divider />
        <ProductBoxGrid
          items={[
            <Typography>Sie haben eine nicht zufriedenstellende Reaktion der Gegenseite erhalten? Dann laden Sie uns diese bitte hoch:</Typography>,
            <Button component={Link} to={getCaseDocumentUploadLink(litigationCase)} variant="contained" color="primary" fullWidth>
              Dokument hochladen
            </Button>,
          ]}
        />
      </Stack>
    );
  }

  return null;
};
